export const CALENDAR_ROUTE = '/calendar';
